import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import IconButton from "@material-ui/core/IconButton";
import igLogo from "resources/img/ig_icon.png";
import validator from "validator";

export const IGButton = (props) => {
	const { value, style, width, height } = props;
	const [IGLink, setIGLink] = useState();
	const [validURL, setValidURL] = useState(false);

	useEffect(() => {
		if (value) {
			const modifiedUrl = value.trim().startsWith("http") ? value : `https://${value}`;
			setIGLink(modifiedUrl);
			setValidURL(validator.isURL(modifiedUrl));
		} else {
			setValidURL(false);
		}
	}, [value]);

	if (validURL) {
		return (
			<IconButton
				target="_black"
				href={IGLink}
				size={"small"}
				style={{
					...style,
				}}
			>
				<img alt="" src={igLogo} width={width} height={height} />
			</IconButton>
		);
	} else {
		return null;
	}
};

IGButton.propTypes = {
	value: PropTypes.string,
	style: PropTypes.object,
	width: PropTypes.number,
	height: PropTypes.number,
};

IGButton.defaultProps = {
	width: 28,
	height: 28,
};
